<template>
  <div style="background:#f5f5f5;min-height:100vh">
    <div class="van-nav-bar van-nav-bar--fixed" style="background:#fff">
      <div class="van-nav-bar__content">
        <div class="van-nav-bar__left" @click="$router.back()">
          <i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
        </div>
        <div class="van-nav-bar__title van-ellipsis">邀请好友礼金</div>
      </div>
    </div>
    <div style="padding-top:46px;padding:56px 16px 20px">
      <!-- 邀请码 -->
      <div style="background:linear-gradient(135deg,#5d75a2,#8fa5cc);border-radius:12px;padding:20px;color:#fff;text-align:center">
        <div style="font-size:14px;opacity:.9;margin-bottom:8px">我的邀请码</div>
        <div style="font-size:28px;font-weight:700;letter-spacing:4px">{{ inviteCode }}</div>
        <div style="margin-top:14px;display:flex;gap:10px;justify-content:center">
          <div @click="copyCode" style="background:rgba(255,255,255,0.25);border-radius:20px;padding:8px 20px;font-size:13px;cursor:pointer">
            复制邀请码
          </div>
          <div @click="copyLink" style="background:rgba(255,255,255,0.25);border-radius:20px;padding:8px 20px;font-size:13px;cursor:pointer">
            复制邀请链接
          </div>
        </div>
      </div>

      <!-- 礼金规则 -->
      <div style="background:#fff;border-radius:12px;padding:16px;margin-top:14px">
        <div style="font-size:15px;font-weight:700;color:#333;margin-bottom:12px">礼金规则</div>
        <div v-for="(rule,i) in rules" :key="i" style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f5f5f5;font-size:13px">
          <span style="color:#666">{{ rule.label }}</span>
          <span style="color:#5d75a2;font-weight:600">{{ rule.value }}</span>
        </div>
      </div>

      <!-- 邀请记录 -->
      <div style="background:#fff;border-radius:12px;padding:16px;margin-top:14px">
        <div style="font-size:15px;font-weight:700;color:#333;margin-bottom:12px">邀请记录</div>
        <div v-for="(rec,i) in records" :key="i" style="display:flex;justify-content:space-between;align-items:center;padding:10px 0;border-bottom:1px solid #f5f5f5">
          <div>
            <div style="font-size:13px;color:#333">{{ rec.username }}</div>
            <div style="font-size:11px;color:#999;margin-top:3px">{{ rec.date }}</div>
          </div>
          <span style="color:#5d75a2;font-weight:600;font-size:14px">+¥{{ rec.bonus }}</span>
        </div>
        <div v-if="records.length===0" style="text-align:center;color:#ccc;padding:30px 0;font-size:13px">暂无邀请记录</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'invite',
  data() {
    return {
      inviteCode: '',
      rules: [
        { label: '好友注册即可获得', value: '奖励 ¥18' },
        { label: '每5人一档', value: '持续叠加奖励' },
        { label: '无需充值，无任何门槛', value: '注册即送' },
        { label: '无上限邀请', value: '持续获得礼金' },
      ],
      records: [],
    };
  },
  created() {
    let that = this;
    let userInfo = that.$store.state.userInfo;
    that.inviteCode = userInfo.invite_code || userInfo.username || '';
    that.$apiFun.post('/api/invite/records', {}).then(res => {
      if (res.code === 200) that.records = res.data || [];
    }).catch(() => {});
  },
  methods: {
    copyLink() {
      let that = this;
      let link = window.location.origin + "/?pid=" + that.inviteCode;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(link).then(() => {
          that.$parent.showTost(1, "邀请链接已复制");
        });
      } else {
        let input = document.createElement("input");
        input.value = link;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        that.$parent.showTost(1, "邀请链接已复制");
      }
    },
    copyCode() {
      let that = this;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(that.inviteCode).then(() => {
          that.$parent.showTost(1, '邀请码已复制');
        });
      } else {
        let input = document.createElement('input');
        input.value = that.inviteCode;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        that.$parent.showTost(1, '邀请码已复制');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invite.vue